import { MixPanel } from "lib/mixpanel";

export const useLazyTrackMixpanel = () => {
  return MixPanel.track;
};
